import {BaseContainerModel} from '../base-container.model';
import {app_hostname_hdr_RowClass} from '../../dbschema/app_hostname_hdr.model';
import {app_hostname_ext_RowClass} from '../../dbschema/app_hostname_ext.model';

export class HostnameContainerModel extends BaseContainerModel {
  app_hostname_hdr: app_hostname_hdr_RowClass = new app_hostname_hdr_RowClass();
  app_hostname_exts: app_hostname_ext_RowClass[] = [];
}
